<template>
  <v-card :href="resourceHref(value)" class="fill-height" rounded="0">
    <div v-if="value.item">
      <ImageCover
        v-if="isDownload(value)"
        :aspect-ratio="aspectRatio"
        :value="value.item"
        content-class="d-flex align-end"
        default-key="download_default_image"
      />
    </div>

    <v-card-item v-if="value.item.title">
      <h5 class="text-subtitle-1 font-weight-bold">{{ value.item.title }}</h5>
    </v-card-item>

    <v-card-text
      v-if="value.item.summary"
      class="text-body-1"
      style="line-height: 150%"
    >
      {{ value.item.summary }}
    </v-card-text>
  </v-card>
</template>

<script setup>
import { isDownload, resourceHref } from '#root/lib/utils'

defineProps({
  value: {
    required: true,
    type: Object
  }
})

const aspectRatio = 4 / 3
</script>
